<style>
.hello {
  height: 600px !important;
  margin-top: 20px;
}
</style>

<template>
  <div style="padding:40px;background-color:#fff">
    <div>
      <b
        ><h3>{{ title }}</h3></b
      >
    </div>
    <br />
    <v-layout>
      <v-toolbar style="box-shadow:none;background-color:#fff">
        <v-layout>
          <v-row>
            <v-col>
              <div>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      label="Start Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu.save(date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col>
              <div>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="date2"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date2"
                      label="End Date"
                      append-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date2" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >Cancel</v-btn
                    >
                    <v-btn text color="primary" @click="$refs.menu2.save(date2)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col>
              <v-select
                item-text="plant_name"
                item-value="plant_code"
                v-model="plant"
                :items="list_plant"
                label="Choose Plant"
              ></v-select>
            </v-col>
            <v-col>
              <div>
                <v-btn color="primary" depressed v-on:click="getData">
                  Search
                </v-btn>

                <v-btn
                  class="ml-2"
                  color="success"
                  depressed
                  dark
                  v-on:click="reset"
                >
                  Clear Filter
                </v-btn>

                <v-progress-circular
                  indeterminate
                  class="ml-2"
                  color="primary"
                  v-if="loading"
                ></v-progress-circular>
              </div>
            </v-col>
          </v-row>
        </v-layout>
      </v-toolbar>
    </v-layout>
    <br />
    <div class="hello" id="chartdiv"></div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import moment from "moment"
import am4themes_animated from "@amcharts/amcharts4/themes/animated"
am4core.useTheme(am4themes_animated)

export default {
  methods: {
    getData() {
      var self = this
      var url = self.base_url + "material/dashboard/doneRatio"
      self.loading = true

      var data = {
        plant: self.plant,
        startdate: self.date,
        enddate: self.date2,
      }

      if (self.storage_role === "REQ") {
        data.requester = self.storage_user_id
      }

      self.axios.post(url, data).then(function(response) {
        var request = response.data.waiting_cataloguing || 0
        var review = response.data.approved || 0
        var done = response.data.registered_on_sap || 0

        self.request = request
        self.review = review
        self.done = done

        self.loading = false

        self.chart()
      })
    },
    reset() {
      var self = this
      self.plant = ""
      self.date = ""
      self.date2 = ""
      this.getData()
    },
    chart() {
      var self = this
      am4core.ready(function() {
        am4core.useTheme(am4themes_animated)
        var chart = am4core.create("chartdiv", am4charts.PieChart)
        chart.hiddenState.properties.opacity = 0

        chart.legend = new am4charts.Legend()

        chart.data = [
          {
            label: "Request",
            val: self.request,
          },
          {
            label: "Review",
            val: self.review,
          },
          {
            label: "Done",
            val: self.done,
          },
        ]

        var series = chart.series.push(new am4charts.PieSeries3D())
        series.dataFields.value = "val"
        series.dataFields.category = "label"

        var colors = ["#67b7dc", "#6771dc", "#26A69A"]
        var colorset = new am4core.ColorSet()

        colorset.list = []

        for (var i = 0; i < colors.length; i++) {
          colorset.list.push(new am4core.color(colors[i]))
          series.colors = colorset
        }
      })
    },
    getPlant() {
      var self = this
      var url = self.base_url + "master/dropdown/attribute/plant/plant_code"
      self.axios.get(url).then(function(response) {
        self.list_plant = response.data
      })
    },
    getDateMonth() {
      this.date = moment()
        .startOf("month")
        .format("YYYY-MM-DD")
      this.date2 = moment()
        .endOf("month")
        .format("YYYY-MM-DD")
    },
  },
  mounted() {
    if (
      this.storage_role != "CAT" &&
      this.storage_role != "ADM" &&
      this.storage_role != "APP1" &&
      this.storage_role != "REQ"
    ) {
      this.$router.push("/login")
    }

    // this.getDateMonth()
    this.getData()
    this.getPlant()
  },
  data() {
    return {
      name: "RequestRatio",
      title: "Done - Request Ratio",
      items: [],
      desserts: [],
      loading: false,
      date: "",
      date2: "",
      waiting_sap: 0,
      rejected: 0,
      list_plant: [],
      plant: null,
      request: 0,
      review: 0,
      done: 0,

      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
    }
  },
}
</script>
